var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopographicalLinesOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f63402fe-d8b9-496b-b847-5cea469d07db",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1925.39 185.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,103.56s18.21,1.63,50.75,10.58c0,0,144.4,37.42,294.1-41.09,0,0,.41-2.85,26.85,0s114.71,6.1,114.71,6.1,9.35-.81,22,2.85,39.46,10.58,57.77,3.66,115.12-48.41,165.56-39S915.56,84.15,915.56,84.15s89.49,21.44,154.58-1.74a318.56,318.56,0,0,1,34.57-7.73,219.3,219.3,0,0,0,35.39-9s46-14.64,63.05-14.24a218.67,218.67,0,0,0,37.43-.4c19.11-2,242.84-22.78,299-1.23S1618.47,69,1618.47,69s36.61-1.62,89.5-12.2S1780,42.14,1817,36s103.32-24,105-26.44",
    transform: "translate(1.8 -8.48)",
    style: {
      fill: "none",
      stroke: "#f6b11c",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.73,148.71s95.6,3.49,188.34,25.22,94,17.9,94,17.9,34.17,2,41.9-3.25S386.34,187,386.34,187s98-.41,150.51-4.07S631.63,180,631.63,180s65.9-5.28,112.27-22,49.22-19.12,72.41-23.19c0,0,16.67-2.85,22.78-5.69s19.11-2,19.11-2,19.12-.47,49.63-4.1S1070.54,99.49,1134,155.22c0,0,32.14,43.12,70.78,23.59s70.78-44.74,70.78-44.74,42.3-43.53,190.37-29.7c0,0,34.58,4.07,50.44,8.55s46.78,3.25,46.78,3.25l129.76-5.7s19.53-1.62,52.07,7.73,90.31,21.16,90.31,21.16,31.73,6.1,54.91.81,31.73-1.22,31.73-1.22",
    transform: "translate(1.8 -8.48)",
    style: {
      fill: "none",
      stroke: "#f6b11c",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopographicalLinesOrange);
export default __webpack_public_path__ + "static/media/topographical-lines-orange.e5b4dc8af96731601623f71913de62e3.svg";
export { ForwardRef as ReactComponent };